import React from "react";

const Step2 = (props) => {
  const {
    eventData = {},
    handleInputChange = () => {},
    errors = {}
  } = props || {};

  const safeEventData = eventData || {};
  const safeErrors = errors || {};

  const getCurrentAustralianDate = () => {
    const now = new Date();
    const date = new Date(now.toLocaleString("en-AU", { timeZone: "Australia/Sydney" }));
    const year = date.getFullYear().toString().padStart(4, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const getCurrentAustralianTime = () => {
    const now = new Date();
    const date = new Date(now.toLocaleString("en-AU", { timeZone: "Australia/Sydney" }));
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  };

  // Direct input handler - NO transformations whatsoever
  const safeHandleInputChange = (field, value, formType = 'event') => {
    if (typeof handleInputChange === 'function') {
      handleInputChange(field, value, formType);
    }
  };

  const currentDate = getCurrentAustralianDate();
  const currentTime = getCurrentAustralianTime();

  return (
    <>
      {/* Event Date & Time - Now Editable */}
      <div style={{ marginBottom: "2rem" }}>
        <div style={{ position: "relative" }}>
          <div style={{
            position: "absolute",
            top: "-0.6rem",
            left: "1rem",
            fontSize: "0.85rem",
            fontWeight: 500,
            color: "#374151",
            backgroundColor: "rgba(255, 255, 255, 0.75)",
            padding: "0 0.25rem",
            borderRadius: "4px",
            zIndex: 1
          }}>
            Event Date & Time <span style={{ color: "#f97316" }}>*</span>
          </div>
          <input
            type="datetime-local"
            value={`${safeEventData.eventDate || currentDate}T${safeEventData.eventTime || currentTime}`}
            onChange={e => {
              const [date, time] = e.target.value.split("T");
              safeHandleInputChange("eventDate", date, "event");
              safeHandleInputChange("eventTime", time, "event");
              safeHandleInputChange("eventDateTime", e.target.value, "event");
            }}
            style={{
              width: "100%",
              padding: "0.75rem 1rem",
              backgroundColor: "white",
              border: (safeErrors.eventDate || safeErrors.eventDateTime) ? "1px solid #ef4444" : "1px solid #d1d5db",
              borderRadius: "0.35rem",
              boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
              fontSize: "0.85rem",
              outline: "none",
              transition: "all 0.2s ease",
              boxSizing: "border-box"
            }}
            onFocus={(e) => {
              e.target.style.borderColor = "#0377fc";
              e.target.style.boxShadow = "0 0 0 2px rgba(3, 119, 252, 0.2)";
            }}
            onBlur={(e) => {
              e.target.style.borderColor = (safeErrors.eventDate || safeErrors.eventDateTime) ? "#ef4444" : "#d1d5db";
              e.target.style.boxShadow = (safeErrors.eventDate || safeErrors.eventDateTime) ? "none" : "0 1px 2px 0 rgba(0, 0, 0, 0.05)";
            }}
          />
        </div>
        {(safeErrors.eventDate || safeErrors.eventDateTime) && (
          <div style={{ marginTop: "0.25rem", color: "#ef4444", fontSize: "0.85rem" }}>
            {safeErrors.eventDate || safeErrors.eventDateTime}
          </div>
        )}
      </div>

      <div style={{ marginBottom: "2rem" }}>
        <div style={{ position: "relative" }}>
          <div style={{
            position: "absolute",
            top: "-0.6rem",
            left: "1rem",
            fontSize: "0.85rem",
            fontWeight: 500,
            color: "#374151",
            backgroundColor: "rgba(255, 255, 255, 0.75)",
            padding: "0 0.25rem",
            borderRadius: "4px",
            zIndex: 1
          }}>
            Staff Requested <span style={{ color: "#f97316" }}>*</span>
          </div>
          <input
            type="number"
            min="0"
            step="1"
            value={safeEventData.staffRequested || ''}
            onChange={e => safeHandleInputChange("staffRequested", e.target.value, "event")}
            placeholder="Enter number of staff requested"
            style={{
              width: "100%",
              padding: "0.75rem 1rem",
              backgroundColor: "white",
              border: safeErrors.staffRequested ? "1px solid #ef4444" : "1px solid #d1d5db",
              borderRadius: "0.35rem",
              boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
              fontSize: "0.85rem",
              outline: "none",
              transition: "all 0.2s ease",
              boxSizing: "border-box"
            }}
            onFocus={(e) => {
              e.target.style.borderColor = "#0377fc";
              e.target.style.boxShadow = "0 0 0 2px rgba(3, 119, 252, 0.2)";
            }}
            onBlur={(e) => {
              e.target.style.borderColor = safeErrors.staffRequested ? "#ef4444" : "#d1d5db";
              e.target.style.boxShadow = safeErrors.staffRequested ? "none" : "0 1px 2px 0 rgba(0, 0, 0, 0.05)";
            }}
            onKeyDown={e => {
              if (e.key === "-" || e.key === "+") e.preventDefault();
              if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
                e.preventDefault();
              }
            }}
          />
        </div>
        {safeErrors.staffRequested && (
          <div style={{ marginTop: "0.25rem", color: "#ef4444", fontSize: "0.85rem" }}>
            {safeErrors.staffRequested}
          </div>
        )}
      </div>

      <div style={{ marginBottom: "2rem" }}>
        <div style={{ position: "relative" }}>
          <div style={{
            position: "absolute",
            top: "-0.6rem",
            left: "1rem",
            fontSize: "0.85rem",
            fontWeight: 500,
            color: "#374151",
            backgroundColor: "rgba(255, 255, 255, 0.75)",
            padding: "0 0.25rem",
            borderRadius: "4px",
            zIndex: 1
          }}>
            Staff Signed On <span style={{ color: "#f97316" }}>*</span>
          </div>
          <input
            type="number"
            min="0"
            step="1"
            value={safeEventData.staffSignedOn || ''}
            onChange={e => safeHandleInputChange("staffSignedOn", e.target.value, "event")}
            placeholder="Enter number of staff who signed on"
            style={{
              width: "100%",
              padding: "0.75rem 1rem",
              backgroundColor: "white",
              border: safeErrors.staffSignedOn ? "1px solid #ef4444" : "1px solid #d1d5db",
              borderRadius: "0.35rem",
              boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
              fontSize: "0.85rem",
              outline: "none",
              transition: "all 0.2s ease",
              boxSizing: "border-box"
            }}
            onFocus={(e) => {
              e.target.style.borderColor = "#0377fc";
              e.target.style.boxShadow = "0 0 0 2px rgba(3, 119, 252, 0.2)";
            }}
            onBlur={(e) => {
              e.target.style.borderColor = safeErrors.staffSignedOn ? "#ef4444" : "#d1d5db";
              e.target.style.boxShadow = safeErrors.staffSignedOn ? "none" : "0 1px 2px 0 rgba(0, 0, 0, 0.05)";
            }}
            onKeyDown={e => {
              if (e.key === "-" || e.key === "+") e.preventDefault();
              if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
                e.preventDefault();
              }
            }}
          />
        </div>
        {safeErrors.staffSignedOn && (
          <div style={{ marginTop: "0.25rem", color: "#ef4444", fontSize: "0.85rem" }}>
            {safeErrors.staffSignedOn}
          </div>
        )}
      </div>

      <div style={{ marginBottom: "2rem" }}>
        <div style={{ position: "relative" }}>
          <div style={{
            position: "absolute",
            top: "-0.6rem",
            left: "1rem",
            fontSize: "0.85rem",
            fontWeight: 500,
            color: "#374151",
            backgroundColor: "rgba(255, 255, 255, 0.75)",
            padding: "0 0.25rem",
            borderRadius: "4px",
            zIndex: 1
          }}>
            General Summary <span style={{ color: "#f97316" }}>*</span>
          </div>
          <textarea
            value={safeEventData.generalSummary || ''}
            onChange={e => safeHandleInputChange("generalSummary", e.target.value, "event")}
            placeholder="Enter a summary of the event"
            style={{
              width: "100%",
              minHeight: "120px",
              padding: "0.75rem 1rem",
              backgroundColor: "white",
              border: safeErrors.generalSummary ? "1px solid #ef4444" : "1px solid #d1d5db",
              borderRadius: "0.35rem",
              boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
              fontSize: "0.85rem",
              outline: "none",
              transition: "all 0.2s ease",
              boxSizing: "border-box",
              resize: "vertical"
            }}
            onFocus={(e) => {
              e.target.style.borderColor = "#0377fc";
              e.target.style.boxShadow = "0 0 0 2px rgba(3, 119, 252, 0.2)";
            }}
            onBlur={(e) => {
              e.target.style.borderColor = safeErrors.generalSummary ? "#ef4444" : "#d1d5db";
              e.target.style.boxShadow = safeErrors.generalSummary ? "none" : "0 1px 2px 0 rgba(0, 0, 0, 0.05)";
            }}
          />
        </div>
        {safeErrors.generalSummary && (
          <div style={{ marginTop: "0.25rem", color: "#ef4444", fontSize: "0.85rem" }}>
            {safeErrors.generalSummary}
          </div>
        )}
      </div>
    </>
  );
};

export default Step2;